export default __webpack_public_path__ + "static/media/73.9ed0c590.gif";